import {
  StyleSheet,
  Text,
  TextInput,
  TouchableOpacity,
  View,
  Image,
  Pressable,
  Modal,
} from "react-native";
import { modalStyleSheet } from "../../components/modalStyle";
import * as React from "react";
import { useState, useContext } from "react";

import Ionicons from "@expo/vector-icons/Ionicons";

import { useTogglePasswordVisibility } from "../../hooks/useTogglePasswordVisibility";

import { getUserByEmail, getAllUsersEmail, newUserLogin } from "../../api";

import CryptoES from "crypto-es";

import AsyncStorage from "@react-native-async-storage/async-storage";

//RESPONSIVE
import "@expo/match-media";
import { useMediaQuery } from "react-responsive";

//TRADUCCION
import { translations } from "../../components/translations";
import { I18n } from "i18n-js";

const i18n = new I18n(translations);
import { ThemeContext } from "../../components/contexts";

//ESTILOS
const loadAsyncColor = async () => {
  return await AsyncStorage.getItem("@asyncColor");
};
import { useTheme } from "@react-navigation/native";


const LoginScreen = ({ navigation }) => {
  const { setTheme, theme, language, setLanguage } = useContext(ThemeContext);

  const { colors } = useTheme();

  i18n.locale = language;
  i18n.enableFallback = true;

  const [darkIcon, setDarkIcon] = useState("ios-sunny");

  React.useEffect(() => {
    setDarkIcon(theme == "dark" ? "ios-moon" : "ios-sunny");

    loadAsyncColor().then((res) => {
      setTheme(res);
    });
  }, []);

  const changeColor = async () => {
    setTheme(theme == "dark" ? "light" : "dark");

    setDarkIcon(theme == "dark" ? "ios-sunny" : "ios-moon");

    theme == "dark"
      ? await AsyncStorage.setItem("@asyncColor", "light")
      : await AsyncStorage.setItem("@asyncColor", "dark");
    navigation.replace("Login");
  };

  const changeLang = async () => {
    setLanguage(language == "es" ? "en" : "es");
    language == "es"
      ? await AsyncStorage.setItem("@asyncLang", "en")
      : await AsyncStorage.setItem("@asyncLang", "es");
  };

  const { passwordVisibility, rightIcon, handlePasswordVisibility } =
    useTogglePasswordVisibility();

  const navigateRegister = () => {
    navigation.navigate("RegisterReferral");
  };

  const [user, setUser] = useState({
    email: "",
    password: "",
  });

  const handleChange = (name, value) => setUser({ ...user, [name]: value });

  const [displayErrorMail, setdisplayErrorMail] = useState("");
  const [displayErrorPass, setdisplayErrorPass] = useState("");
  const [modalVisible, setModalVisible] = useState(false);
  const [textfieldStyle1, setTextfieldStyle1] = useState([
    styles.loginInputBox,
    { backgroundColor: colors.textInputBackground, borderColor: colors.main },
  ]);
  const [textfieldStyle2, setTextfieldStyle2] = useState([
    styles.loginInputBox,
    { backgroundColor: colors.textInputBackground, borderColor: colors.main },
  ]);

  const storeData = async (value) => {
    await AsyncStorage.setItem("@asyncID", value);
  };

  const handleLogin = () => {
    if (user.password == "") {
      setTextfieldStyle2([
        styles.loginInputBoxError,
        { backgroundColor: colors.errorLight, borderColor: colors.error },
      ]);
      setdisplayErrorPass(i18n.t("introduceContra"));
      setModalVisible(true);
    }

    if (user.email !== "") {
      getAllUsersEmail().then((res) => {
        let string = JSON.stringify(res).toUpperCase();
        if (string.indexOf('"' + user.email.toUpperCase() + '"') > -1) {
          setTextfieldStyle1([
            styles.loginInputBox,
            {
              backgroundColor: colors.textInputBackground,
              borderColor: colors.main,
            },
          ]);
          setdisplayErrorMail("");

          getUserByEmail(user.email).then((result) => {
            if (result.deleted == 0) {
              if (user.password !== "") {
                const encryptedPassword = CryptoES.SHA256(
                  user.password
                ).toString();

                if (encryptedPassword === result.password) {
                  setTextfieldStyle2([
                    styles.loginInputBox,
                    {
                      backgroundColor: colors.textInputBackground,
                      borderColor: colors.main,
                    },
                  ]);
                  newUserLogin(result.id)
                    .then(() => {
                      storeData(result.id.toString());
                    })
                    .then(() => {
                      navigation.replace("Home");
                    });
                } else {
                  setTextfieldStyle2([
                    styles.loginInputBoxError,
                    {
                      backgroundColor: colors.errorLight,
                      borderColor: colors.error,
                    },
                  ]);
                  setdisplayErrorPass(i18n.t("contraIncorrecta"));
                  setModalVisible(true);
                }
              } else {
                setTextfieldStyle2([
                  styles.loginInputBoxError,
                  {
                    backgroundColor: colors.errorLight,
                    borderColor: colors.error,
                  },
                ]);
                setdisplayErrorPass(i18n.t("introduceContra"));
                setModalVisible(true);
              }
            } else {
              setTextfieldStyle1([
                styles.loginInputBoxError,
                {
                  backgroundColor: colors.errorLight,
                  borderColor: colors.error,
                },
              ]);
              setdisplayErrorMail(i18n.t("noExisteCorreo"));
              setModalVisible(true);
            }
          });
        } else {
          setTextfieldStyle1([
            styles.loginInputBoxError,
            { backgroundColor: colors.errorLight, borderColor: colors.error },
          ]);
          setdisplayErrorMail(i18n.t("noExisteCorreo"));
          setModalVisible(true);
        }
      });
    } else {
      setTextfieldStyle1([
        styles.loginInputBoxError,
        { backgroundColor: colors.errorLight, borderColor: colors.error },
      ]);
      setdisplayErrorMail(i18n.t("introduceCorreo"));
      setModalVisible(true);
    }
  };

  const forgottenPassword = () => {
    navigation.navigate("ForgottenPassword");
  };

  const isTabletOrMobileDevice = useMediaQuery({
    maxDeviceWidth: 1224,
    // alternatively...
    query: "(max-device-width: 1224px)",
  });

  if (isTabletOrMobileDevice) {
    return (
      <View style={styles.container}>
        <View style={{ marginBottom: 0 }}>
          <Image
            style={styles.loginImage}
            source={require("./../../assets/MSLogo.png")}
          />
        </View>

        <View>
          <Text
            style={{
              fontFamily: "Kodchasan-Regular",
              marginTop: 60,
              textAlign: "center",
              fontSize: 18,
              color: colors.textColor,
            }}
          >
            Parece que estás utilizando un móvil o una tablet.
          </Text>
          <Text
            style={{
              fontFamily: "Kodchasan-Bold",
              marginTop: 60,
              textAlign: "center",
              color: colors.textColor,
            }}
          >
            Por favor utiliza la aplicación oficial.
          </Text>
        </View>
        <View
          style={{
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            overflow: "visible",
          }}
        >
          <TouchableOpacity
            style={{ width: "100%", height: 100, margin: 25 }}
            onPress={() => {
              window.open(
                "https://play.google.com/store/apps/details?id=com.msinvs.msinvs", '_blank'
              );
            }}
          >
            <Image
              style={{ resizeMode: "contain", width: "100%", height: 100 }}
              source={{
                uri: "https://msinvs.com/webtest/images/googleplay_img.png",
              }}
            />
          </TouchableOpacity>
          <TouchableOpacity
            style={{ width: "100%", height: 100 }}
            onPress={() => {
              window.open(
                "https://apps.apple.com/es/app/msinvs/id1565847618", '_blank'
              );
            }}
          >
            <Image
              style={{ resizeMode: "contain", width: "100%", height: 100 }}
              source={{
                uri: "https://msinvs.com/webtest/images/appstore_img.png",
              }}
            />
          </TouchableOpacity>
        </View>

        <View
          style={{
            flex: 1,
            alignItems: "flex-end",
            justifyContent: "flex-end",
          }}
        >
          <Text style={[styles.copyrightText, { color: colors.textColor }]}>
            {i18n.t("copyright")}
          </Text>
        </View>
      </View>
    );
  }

  return (
    <View
      style={[
        styles.container,
        {
          backgroundColor: colors.main,
          justifyContent: "center",
          margin: 0,
          padding: 0,
        },
      ]}
    >
      <View
        style={[
          {
            justifyContent: "flex-start",
            alignItems: "center",
            padding: 70,
            paddingBottom: 0,
            backgroundColor: colors.background,
            borderRadius: 25,
            width: 450,
            height: 750,
          },
          styles.buttonShadow,
        ]}
      >
        <Modal animationType="fade" transparent={true} visible={modalVisible}>
          <View style={modalStyleSheet.modalContainer}>
            <View
              style={[
                modalStyleSheet.modalBox,
                { backgroundColor: colors.background },
              ]}
            >
              <View style={modalStyleSheet.modalBoxErrorBox}>
                <Text
                  style={[
                    modalStyleSheet.modalBoxError,
                    { color: colors.error },
                  ]}
                >
                  {displayErrorMail}
                  {displayErrorPass}
                </Text>
              </View>
              <Pressable
                style={[
                  modalStyleSheet.modalClose,
                  { backgroundColor: colors.main },
                ]}
                onPress={() => setModalVisible(!modalVisible)}
              >
                <Text
                  style={[
                    modalStyleSheet.modalCloseText,
                    { color: colors.buttonTextColor },
                  ]}
                >
                  {i18n.t("deAcuerdo")}
                </Text>
              </Pressable>
            </View>
          </View>
        </Modal>
        <View style={styles.backButtonContainer}>
          <TouchableOpacity
            onPress={() =>
              window.open("https://rco.msinvs.com/rco/contacto/", '_blank')
            }
          >
            <Ionicons
              name="ios-help-circle-outline"
              size={34}
              color={colors.mainTransparency}
            />
          </TouchableOpacity>
        </View>
        <View style={styles.loginImageContainer}>
          <Image
            style={styles.loginImage}
            source={require("./../../assets/MSLogo.png")}
          />

          <View style={styles.loginOptionsContainer}>
            <TouchableOpacity
              onPress={() => changeLang()}
              style={[
                styles.loginOptionsButton,
                styles.buttonShadow,
                {
                  backgroundColor: colors.textInputBackground,
                  shadowColor: colors.shadowColor,
                },
              ]}
            >
              <Text
                style={[
                  styles.loginOptionsButtonText,
                  { color: colors.textColor },
                ]}
              >
                {i18n.t("lang")}
              </Text>
            </TouchableOpacity>
            <TouchableOpacity
              onPress={() => changeColor()}
              style={[
                styles.loginOptionsButton,
                styles.buttonShadow,
                {
                  backgroundColor: colors.textInputBackground,
                  shadowColor: colors.shadowColor,
                },
              ]}
            >
              <Ionicons name={darkIcon} size={24} color={colors.textColor} />
            </TouchableOpacity>
          </View>
        </View>
        <View style={styles.loginInputContainer}>
          <View style={textfieldStyle1}>
            <Ionicons
              style={styles.loginInputBoxIcon}
              name="ios-mail"
              size={24}
              color={colors.main}
            />
            <TextInput
              autoComplete="email"
              keyboardType="email-address"
              placeholder={i18n.t("correoElectronico")}
              placeholderTextColor={colors.mainTransparency}
              onChangeText={(text) => handleChange("email", text)}
              style={[styles.loginInput, { color: colors.main }]}
            />
          </View>
          <View style={textfieldStyle2}>
            <Ionicons
              style={styles.loginInputBoxIcon}
              name="ios-lock-closed"
              size={24}
              color={colors.main}
            />
            <TextInput
              placeholder={i18n.t("contra")}
              placeholderTextColor={colors.mainTransparency}
              onChangeText={(text) => handleChange("password", text)}
              secureTextEntry={passwordVisibility}
              style={[styles.loginInputVisibility, { color: colors.main }]}
            />
            <Pressable onPress={handlePasswordVisibility}>
              <Ionicons
                name={rightIcon}
                size={24}
                color={colors.mainTransparency}
              />
            </Pressable>
          </View>
        </View>
        <View style={styles.loginButtonContainer}>
          <TouchableOpacity
            onPress={forgottenPassword}
            style={styles.loginForgotten}
          >
            <Text
              style={[styles.loginForgottenText, { color: colors.textColor }]}
            >
              {i18n.t("contraOlvidada")}
            </Text>
          </TouchableOpacity>
          <TouchableOpacity
            onPress={handleLogin}
            style={[
              styles.loginButton,
              styles.buttonShadow,
              { backgroundColor: colors.main, shadowColor: colors.shadowColor },
            ]}
          >
            <Text
              style={[
                styles.loginButtonText,
                { color: colors.buttonTextColor },
              ]}
            >
              {i18n.t("iniciarSesion")}
            </Text>
          </TouchableOpacity>
        </View>

        <View style={styles.registerButtonContainer}>
          <Text style={[styles.noTienes, { color: colors.textColor }]}>
            {i18n.t("noTienesCuenta")}
          </Text>

          <TouchableOpacity onPress={navigateRegister}>
            <Text style={[styles.registerButtonText, { color: colors.main }]}>
              {i18n.t("registrate")}
            </Text>
          </TouchableOpacity>
          <Text style={[styles.copyrightText, { color: colors.textColor }]}>
            {i18n.t("copyright")}
          </Text>
        </View>
      </View>
    </View>
  );
};

export default LoginScreen;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: "flex-start",
    alignItems: "center",
    padding: 70,
    paddingTop: 66,
    paddingBottom: 0,
    minHeight: "100%",
  },

  buttonShadow: {
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.3,
    shadowRadius: 4,
    elevation: 3,
  },

  //IMAGEN LOGO
  loginImageContainer: {
    margin: "auto",
    width: "100%",
    height: "auto",
    paddingVertical: 0,
    marginBottom: 50,
  },

  loginImage: {
    alignSelf: "center",
    width: 115,
    height: 115,
    marginBottom: 50,
  },

  //OPTIONS
  loginOptionsContainer: {
    flex: 1,
    flexDirection: "row",
    justifyContent: "space-evenly",
  },
  loginOptionsButton: {
    justifyContent: "center",
    alignItems: "center",
    width: 50,
    height: 50,
    borderRadius: 10,
  },
  loginOptionsButtonText: {
    fontSize: 16,
    fontFamily: "Roboto-Medium",
  },

  //INPUTS
  loginInputContainer: {
    width: "100%",
  },
  loginInputBox: {
    paddingHorizontal: 15,
    paddingVertical: 10,
    marginBottom: 25,
    borderRadius: 10,
    borderStyle: "solid",
    borderWidth: 2,
    flexDirection: "row",
    justifyContent: "space-between",
  },
  loginInputBoxError: {
    paddingHorizontal: 15,
    paddingVertical: 10,
    marginBottom: 25,
    borderRadius: 10,
    borderStyle: "solid",
    borderWidth: 2,
    flexDirection: "row",
    justifyContent: "space-between",
  },

  loginInput: {
    flex: 1,
    outlineStyle: "none",
    fontFamily: "Kodchasan-Regular",
  },

  loginInputBoxIcon: {
    marginRight: 15,
  },

  visibilityToggle: {
    marginLeft: 10,
  },

  loginInputVisibility: {
    flex: 1,
    outlineStyle: "none",
    fontFamily: "Kodchasan-Regular",
  },

  //LOGIN BUTTON Y FORGOTTEN
  loginButtonContainer: {
    width: "100%",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  loginForgotten: {
    width: "40%",
    textAlign: "center",
  },
  loginForgottenText: {
    fontFamily: "Roboto-Regular",
    textAlign: "center",
  },
  loginButton: {
    width: "55%",
    paddingVertical: 10,
    borderRadius: 20,
    textAlign: "center",
  },
  loginButtonText: {
    textAlign: "center",
    fontSize: 13,
    fontFamily: "Kodchasan-Bold",
  },

  //REGISTER BUTTON

  noTienes: {
    fontFamily: "Roboto-Medium",
  },
  registerButtonContainer: {
    width: "80%",
    flex: 1,
    alignItems: "center",
    justifyContent: "flex-end",
    minHeight: 150,
  },
  registerButtonText: {
    fontSize: 16,
    fontFamily: "Roboto-Medium",
    textAlign: "center",
  },
  copyrightText: {
    marginBottom: "15%",
    marginTop: "5%",
    fontFamily: "Kodchasan-Regular",
    textAlign: "center",
  },

  backButtonContainer: {
    width: "auto",
    position: "absolute",
    top: 70,
    right: 25,
  },
});

